/**
 * Re-attach RTK Query cache tags to codegen endpoints.
 * Codegen's typescript-rtk-query plugin does not emit providesTags/invalidatesTags.
 *
 * Create/update/delete mutations intentionally omit invalidatesTags — org socket
 * patches list/detail caches via applyOrgDataChanged.
 */
import { api as generatedApi } from './generated';

generatedApi.enhanceEndpoints({
  endpoints: {
    ListCustomers: { providesTags: ['Customer'] },
    GetCustomer: {
      providesTags: (_r, _e, arg) => [{ type: 'Customer', id: arg.id }],
    },
    CustomerComments: { providesTags: ['Customer'] },
    AddCustomerComment: { invalidatesTags: ['Customer'] },

    ListVendors: { providesTags: ['Vendor'] },
    GetVendor: {
      providesTags: (_r, _e, arg) => [{ type: 'Vendor', id: arg.id }],
    },

    ListWarehouses: { providesTags: ['Warehouse'] },

    ListLabour: { providesTags: ['Labour'] },

    ListTransport: { providesTags: ['Transport'] },

    ListProcurement: { providesTags: ['Procurement'] },
    GetProcurement: {
      providesTags: (_r, _e, arg) => [{ type: 'Procurement', id: arg.id }],
    },
    ExportProcurement: { invalidatesTags: ['Procurement'] },

    SystemNotifications: { providesTags: ['SystemNotification'] },
  },
});

export {
  useListLabourQuery,
  useLazyListLabourQuery,
  useAddUpdateLabourMutation,
  useDeleteLabourMutation,
  useListTransportQuery,
  useLazyListTransportQuery,
  useAddUpdateTransportMutation,
  useDeleteTransportMutation,
  useListWarehousesQuery,
  useLazyListWarehousesQuery,
  useAddUpdateWarehouseMutation,
  useDeleteWarehouseMutation,
  useSystemNotificationsQuery,
} from './generated';
